import { Box, Divider, ListItemText, MenuItem, MenuList, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useState } from "react";
import { useSearchParams } from "react-router";
import { parseSearchParamWithFallback } from "@entrilia/shared/utilities/searchParamsHelper";
import { PageContainerContextProvider } from "./PageContainerContext";

interface Props {
  menuItems: MenuItemProps[];
}

interface MenuItemProps {
  name: string;
  label: string;
}

const PageContainer = ({ menuItems, children }: PropsWithChildren<Props>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedName, setSelectedName] = useState(() =>
    parseSearchParamWithFallback(
      searchParams,
      "action",
      menuItems.map(({ name }) => name)
    )
  );

  const handleMenuItemClick = (name: string) => {
    setSelectedName(name);
    setSearchParams({ action: name });
  };

  return (
    <PageContainerContextProvider selectedContentName={selectedName}>
      <Box sx={{ position: "relative", display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
        <Box component="nav" sx={{ flexBasis: "17rem", flexShrink: 0, overflow: "auto", p: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Actions
          </Typography>
          <MenuList>
            {menuItems.map((item) => (
              <MenuItem
                key={item.name}
                selected={item.name === selectedName}
                onClick={() => handleMenuItemClick(item.name)}
              >
                <ListItemText>{item.label}</ListItemText>
              </MenuItem>
            ))}
          </MenuList>
        </Box>

        <Divider orientation="vertical" flexItem />

        {children}
      </Box>
    </PageContainerContextProvider>
  );
};

export default PageContainer;
